var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 476,
    viewBox: "0 0 1152 476",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1049.04 -723.74C1204.56 -688.484 1401.78 -659.468 1492.69 -568.365C1583.22 -477.263 1567.07 -324.072 1532.88 -178.058C1498.32 -31.7319 1445.73 107.418 1325.52 167.01C1205.31 226.601 1017.86 206.945 845.432 264.664C673.381 322.072 516.357 456.854 357.454 474.014C198.552 491.486 37.7706 391.335 -72.6724 265.912C-183.491 140.49 -243.972 -10.2042 -266.135 -163.082C-288.299 -315.961 -272.146 -471.335 -180.486 -580.845C-88.4499 -690.044 79.8442 -753.691 233.488 -789.571C387.507 -825.45 526.875 -833.25 653.472 -816.714C780.068 -800.179 893.892 -758.995 1049.04 -723.74Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 310.733,
    y1: -680.177,
    x2: 497.451,
    y2: 445.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87F6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4B3F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.27a76f8c50dc2127250b123d92520d75.svg";
export { ForwardRef as ReactComponent };